.row {
  flex-direction: column;
}

.paragraph {
  width: 100px;
}
